(() => {
    let doc = document,
		body = doc.body;

    const checkScroll = () => {
		let top = window.pageYOffset || doc.documentElement.scrollTop;
		if (top > 100) body.classList.add('scrolled');
		else body.classList.remove('scrolled');
	};

	window.onscroll = function (e) {
		checkScroll();
	};

	checkScroll();

	// Mobile nav toggle
	const toggle = doc.querySelector('.header__toggle');
	const mobileNav = doc.querySelector('.mobile-nav');
	const closeBtn = doc.querySelector('.mobile-nav__close');

	const closeMobileNav = () => {
		toggle.classList.remove('active');
		mobileNav.classList.remove('active');
		body.classList.remove('nav-open');
		toggle.setAttribute('aria-expanded', 'false');
	};

	if (toggle && mobileNav) {
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('active');
			mobileNav.classList.toggle('active');
			body.classList.toggle('nav-open');
			toggle.setAttribute('aria-expanded', toggle.classList.contains('active'));
		});

		if (closeBtn) {
			closeBtn.addEventListener('click', closeMobileNav);
		}
	}

	// Make the whole Gravity Forms file upload area clickable
	doc.addEventListener('click', (e) => {
		const uploadArea = e.target.closest('.ginput_container_fileupload');
		if (!uploadArea) return;

		if (e.target.closest('.gform_button_select_files, input[type="file"], .ginput_preview, a, button')) return;

		const selectButton = uploadArea.querySelector('.gform_button_select_files');
		const fileInput = uploadArea.querySelector('input[type="file"]');

		if (selectButton) {
			selectButton.click();
		} else if (fileInput) {
			fileInput.click();
		}
	});

	// Drag-and-drop support for basic Gravity Forms file upload
	doc.querySelectorAll('.ginput_container_fileupload').forEach((area) => {
		if (area.querySelector('.gform_drop_area')) return;

		const fileInput = area.querySelector('input[type="file"]');
		if (!fileInput) return;

		['dragenter', 'dragover'].forEach((evt) => {
			area.addEventListener(evt, (e) => {
				e.preventDefault();
				e.stopPropagation();
				area.classList.add('is-dragover');
			});
		});

		['dragleave', 'dragend'].forEach((evt) => {
			area.addEventListener(evt, (e) => {
				e.preventDefault();
				e.stopPropagation();
				area.classList.remove('is-dragover');
			});
		});

		area.addEventListener('drop', (e) => {
			e.preventDefault();
			e.stopPropagation();
			area.classList.remove('is-dragover');

			const files = e.dataTransfer && e.dataTransfer.files;
			if (!files || files.length === 0) return;

			try {
				const dataTransfer = new DataTransfer();
				Array.from(files).forEach((file) => dataTransfer.items.add(file));
				fileInput.files = dataTransfer.files;
				fileInput.dispatchEvent(new Event('change', { bubbles: true }));
			} catch (err) {
				fileInput.files = files;
				fileInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		});
	});

	// Animate elements on scroll
	const animatedElements = document.querySelectorAll(
		'.fade-in, .slide-in-from-top, .slide-in-from-bottom, .slide-in-from-left, .slide-in-from-right'
	);
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate');
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.1 }
	);
	animatedElements.forEach((el) => observer.observe(el));

	// Hero background slider
	const heroSlider = doc.querySelector('.hero-section__background--slider');
	if (heroSlider) {
		const slides = heroSlider.querySelectorAll('.hero-section__slide');
		if (slides.length > 1) {
			let current = 0;
			setInterval(() => {
				slides[current].classList.remove('is-active');
				current = (current + 1) % slides.length;
				slides[current].classList.add('is-active');
			}, 5000);
		}
	}

	// Scale page title to fill container width
	const pageTitle = doc.querySelector('.page-title-section__title');
	if (pageTitle) {
		const scaleTitle = () => {
			const baseFontSize = 160;
			pageTitle.style.fontSize = baseFontSize + 'px';
			pageTitle.style.display = 'inline';
			const textWidth = pageTitle.getBoundingClientRect().width;
			pageTitle.style.display = '';
			const container = pageTitle.parentElement;
			const cs = getComputedStyle(container);
			const availableWidth = container.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
			if (textWidth > 0) {
				const newSize = baseFontSize * (availableWidth / textWidth);
				pageTitle.style.fontSize = newSize + 'px';
			}
		};
		scaleTitle();
		window.addEventListener('resize', scaleTitle);
	}

	// Projects archive: AJAX "meer projecten tonen"
	const projectsGrid = doc.querySelector('.projects-page__grid');
	const projectsMoreBtn = doc.querySelector('.projects-page__more-link');
	if (projectsGrid && projectsMoreBtn) {
		projectsMoreBtn.addEventListener('click', () => {
			const url = projectsMoreBtn.dataset.nextUrl;
			if (!url) return;

			projectsMoreBtn.classList.add('is-loading');
			projectsMoreBtn.disabled = true;

			fetch(url)
				.then((response) => response.text())
				.then((html) => {
					const parser = new DOMParser();
					const newDoc = parser.parseFromString(html, 'text/html');
					const newCards = newDoc.querySelectorAll('.projects-page__grid .projects-page__card');
					newCards.forEach((card) => projectsGrid.appendChild(card));

					const newMoreBtn = newDoc.querySelector('.projects-page__more-link');
					if (newMoreBtn && newMoreBtn.dataset.nextUrl) {
						projectsMoreBtn.dataset.nextUrl = newMoreBtn.dataset.nextUrl;
					} else {
						projectsMoreBtn.closest('.projects-page__more').remove();
					}
				})
				.finally(() => {
					projectsMoreBtn.classList.remove('is-loading');
					projectsMoreBtn.disabled = false;
				});
		});
	}

	// Gallery masonry: merge a run of directly-consecutive two-image gallery
	// sections into one two-column layout. Each section's first image flows down
	// the left column and its second image down the right column, so the columns
	// pack independently and the gaps under short images are filled by the next
	// section's image on that side.
	const buildGalleryMasonry = () => {
		const isTwoUp = (section) =>
			!!section &&
			section.classList.contains('gallery-section') &&
			!!section.querySelector('.gallery-section__grid--2');

		const sections = Array.from(doc.querySelectorAll('.gallery-section'));
		let i = 0;
		while (i < sections.length) {
			if (!isTwoUp(sections[i])) {
				i++;
				continue;
			}

			// Collect a run of two-up sections that are adjacent DOM siblings.
			const run = [sections[i]];
			let next = i + 1;
			while (
				next < sections.length &&
				isTwoUp(sections[next]) &&
				sections[next].previousElementSibling === run[run.length - 1]
			) {
				run.push(sections[next]);
				next++;
			}

			if (run.length >= 2) {
				const masonry = doc.createElement('div');
				masonry.className = 'gallery-masonry';
				const leftCol = doc.createElement('div');
				leftCol.className = 'gallery-masonry__col gallery-masonry__col--left';
				const rightCol = doc.createElement('div');
				rightCol.className = 'gallery-masonry__col gallery-masonry__col--right';
				masonry.append(leftCol, rightCol);
				run[0].parentNode.insertBefore(masonry, run[0]);

				let order = 0;
				run.forEach((section) => {
					const items = section.querySelectorAll('.gallery-section__item');
					items.forEach((item, index) => {
						// `order` keeps upload order on mobile (single column) and
						// for the lightbox; column placement keeps left/right sides.
						item.style.order = String(order);
						item.dataset.order = String(order);
						order++;
						(index === 0 ? leftCol : rightCol).appendChild(item);
					});
					section.remove();
				});
			}

			i = next;
		}
	};

	buildGalleryMasonry();

	// Gallery popup
	const popup = doc.querySelector('.gallery-popup');
	if (popup) {
		const popupImage = popup.querySelector('.gallery-popup__image');
		const closeBtn = popup.querySelector('.gallery-popup__close');
		const prevBtn = popup.querySelector('.gallery-popup__nav-link--prev');
		const nextBtn = popup.querySelector('.gallery-popup__nav-link--next');
		const nav = popup.querySelector('.gallery-popup__nav');

		let currentImages = [];
		let currentAlts = [];
		let currentIndex = 0;

		const updateImage = () => {
			if (currentImages.length === 0) return;
			popupImage.src = currentImages[currentIndex];
			popupImage.alt = currentAlts[currentIndex] || '';
			nav.style.display = currentImages.length > 1 ? '' : 'none';
		};

		const openPopup = (images, alts, index) => {
			currentImages = images;
			currentAlts = alts;
			currentIndex = index;
			updateImage();
			popup.hidden = false;
			body.classList.add('gallery-popup-open');
		};

		const closePopup = () => {
			popup.hidden = true;
			body.classList.remove('gallery-popup-open');
		};

		const prevImage = () => {
			currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
			updateImage();
		};

		const nextImage = () => {
			currentIndex = (currentIndex + 1) % currentImages.length;
			updateImage();
		};

		// One lightbox group per standalone section and per merged masonry run.
		// Merged sections were removed from the DOM, so querying for
		// `.gallery-section` only returns the remaining standalone ones.
		const galleryGroups = [
			...doc.querySelectorAll('.gallery-masonry'),
			...doc.querySelectorAll('.gallery-section'),
		];

		galleryGroups.forEach((group) => {
			const items = Array.from(group.querySelectorAll('.gallery-section__item'));
			if (group.classList.contains('gallery-masonry')) {
				items.sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));
			}

			const images = items.map((item) => item.dataset.imageFull);
			const alts = items.map((item) => {
				const img = item.querySelector('img');
				return img ? img.alt : '';
			});

			items.forEach((item, index) => {
				item.addEventListener('click', () => openPopup(images, alts, index));
			});
		});

		closeBtn.addEventListener('click', closePopup);
		prevBtn.addEventListener('click', prevImage);
		nextBtn.addEventListener('click', nextImage);

		popup.addEventListener('click', (e) => {
			if (e.target === popup) closePopup();
		});

		doc.addEventListener('keydown', (e) => {
			if (popup.hidden) return;
			if (e.key === 'Escape') closePopup();
			else if (e.key === 'ArrowLeft') prevImage();
			else if (e.key === 'ArrowRight') nextImage();
		});
	}
})();
